import { FaBriefcase, FaMapPin, FaUser, FaGear, FaFolderOpen, FaClock, FaFileLines, FaWandMagicSparkles, FaCalendarDays, FaChartLine } from "react-icons/fa6";
import { u2000MenuGetIcon, type U2000MenuItem } from "./U2000MenuUtils";

export interface U2000MenuModule extends U2000MenuItem {
  id: string;
  type: string;
  label: string;
  icon?: React.ReactElement;
  breadCrumIcon?: React.ReactElement;
  menuItems?: U2000MenuItem[];
}

export const u2000Menu: U2000MenuModule[] = [
  {
    id: "U3120",
    type: "module",
    label: "lblMnuProject",
    icon: u2000MenuGetIcon(FaFolderOpen, "h-4 w-4"),
    breadCrumIcon: u2000MenuGetIcon(FaFolderOpen, "h-6 w-6"),
    menuItems: [
      {
        id: "U3121",
        type: "menu",
        label: "lblMnuU3121",
        link: "/U3121",
        allowedRoles: ["U3121:READ"],
        showInGlobalSearch: true,
        quickSearchFieldName: "projetNumber",
        quickSearchCondition: "contains",
        quickSearchOrder: 1,
      },
      {
        id: "U3500",
        type: "menu",
        label: "lblMnuU3500",
        link: "/U3500",
        allowedRoles: ["U3500:READ"],
        showInGlobalSearch: true,
        quickSearchFieldName: "fileName",
        quickSearchCondition: "contains",
        quickSearchOrder: 2,
      },
      {
        id: "U3120",
        type: "menu",
        label: "lblMnuU3120",
        link: "/U3120",
        allowedRoles: ["U3120:READ"],
        showInGlobalSearch: true,
        quickSearchFieldName: "customerCode",
        quickSearchCondition: "contains",
        quickSearchOrder: 3,
      },
      {
        id: "U3134",
        type: "menu",
        label: "lblMnuU3134",
        link: "/U3134",
        allowedRoles: ["U3134:READ"],
        showInGlobalSearch: false,
        quickSearchFieldName: "remark",
        quickSearchCondition: "contains",
      },
      {
        id: "U3125",
        type: "menu",
        label: "lblMnuU3125",
        link: "/U3125",
        allowedRoles: ["U3125:READ"],
        showInGlobalSearch: true,
        quickSearchFieldName: "invoiceNumber",
        quickSearchCondition: "equals",
        quickSearchOrder: 8,
      },
      {
        id: "U3122",
        type: "menu",
        label: "lblMnuU3122",
        link: "/U3122",
        allowedRoles: ["U3122:READ"],
      },
      {
        id: "U3123",
        type: "menu",
        label: "lblMnuU3123",
        link: "/U3123",
        allowedRoles: ["U3123:READ"],
      },
      {
        id: "U3124",
        type: "menu",
        label: "lblMnuU3124",
        link: "/U3124",
        allowedRoles: ["U3124:READ"],
      },
      {
        id: "U3126",
        type: "menu",
        label: "lblMnuU3126",
        link: "/U3126",
        allowedRoles: ["U3126:READ"],
      },
      {
        id: "U3127",
        type: "menu",
        label: "lblMnuU3127",
        link: "/U3127",
        allowedRoles: ["U3127:READ"],
      },
      {
        id: "U3128",
        type: "menu",
        label: "lblMnuU3128",
        link: "/U3128",
        allowedRoles: ["U3128:READ"],
      },
    ],
  },
  {
    id: "U3129",
    type: "module",
    label: "lblMnuTimeSheet",
    icon: u2000MenuGetIcon(FaClock, "h-4 w-4"),
    breadCrumIcon: u2000MenuGetIcon(FaClock, "h-6 w-6"),
    menuItems: [
      {
        id: "U3129",
        type: "menu",
        label: "lblMnuU3129",
        link: "/U3129",
        allowedRoles: ["U3129:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3147",
        type: "menu",
        label: "lblMnuU3147",
        link: "/U3147",
        allowedRoles: ["U3147:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3130",
        type: "menu",
        label: "lblMnuU3130",
        link: "/U3130",
        allowedRoles: ["U3130:READ"],
      },
      {
        id: "U3131",
        type: "menu",
        label: "lblMnuU3131",
        link: "/U3131",
        allowedRoles: ["U3131:READ"],
      },
      {
        id: "U3132",
        type: "menu",
        label: "lblMnuU3132",
        link: "/U3132",
        allowedRoles: ["U3132:READ"],
      },
      {
        id: "U3133",
        type: "menu",
        label: "lblMnuU3133",
        link: "/U3133",
        allowedRoles: ["U3133:READ"],
      },
      {
        id: "U3135",
        type: "menu",
        label: "lblMnuU3135",
        link: "/U3135",
        allowedRoles: ["U3135:READ"],
      },
      {
        id: "U3136",
        type: "menu",
        label: "lblMnuU3136",
        link: "/U3136",
        allowedRoles: ["U3136:READ"],
      },
      {
        id: "U3137",
        type: "menu",
        label: "lblMnuU3137",
        link: "/U3137",
        allowedRoles: ["U3137:READ"],
      },
      {
        id: "U3138",
        type: "menu",
        label: "lblMnuU3138",
        link: "/U3138",
        allowedRoles: ["U3138:READ"],
      },
    ],
  },
  {
    id: "M3140",
    type: "module",
    label: "lblMnuLandManagement",
    icon: u2000MenuGetIcon(FaMapPin, "h-4 w-4"),
    breadCrumIcon: u2000MenuGetIcon(FaMapPin, "h-6 w-6"),
    menuItems: [
      {
        id: "U3141",
        type: "menu",
        label: "lblMnuLandRegister",
        link: "/U3141",
        allowedRoles: ["U3141:READ"],
        showInGlobalSearch: true,
        quickSearchFieldName: "projectNumber",
        quickSearchCondition: "contains",
        quickSearchOrder: 5,
      },
      {
        id: "U3142",
        type: "menu",
        label: "lblMnuLot",
        link: "/U3142",
        allowedRoles: ["U3142:READ"],
        showInGlobalSearch: true,
        quickSearchFieldName: "lot",
        quickSearchCondition: "contains",
        quickSearchOrder: 4,
      },
    ],
  },
  {
    id: "U3139",
    type: "module",
    label: "lblMnuMinutes",
    icon: u2000MenuGetIcon(FaFileLines, "h-4 w-4"),
    breadCrumIcon: u2000MenuGetIcon(FaFileLines, "h-6 w-6"),
    menuItems: [
      {
        id: "U3139",
        type: "menu",
        label: "lblMnuU3139",
        link: "/U3139",
        allowedRoles: ["U3139:READ"],
        showInGlobalSearch: true,
        quickSearchFieldName: "minuteNumber",
        quickSearchCondition: "contains",
        quickSearchOrder: 6,
      },
      {
        id: "U3140",
        type: "menu",
        label: "lblMnuU3140",
        link: "/U3140",
        allowedRoles: ["U3140:READ"],
      },
    ],
  },
  {
    id: "U3300",
    type: "module",
    label: "lblMnuModuleCalendar",
    icon: u2000MenuGetIcon(FaCalendarDays, "h-4 w-4"),
    breadCrumIcon: u2000MenuGetIcon(FaCalendarDays, "h-6 w-6"),
    menuItems: [
      {
        id: "U3301",
        type: "menu",
        label: "lblMnuU3301",
        link: "/U3301",
        allowedRoles: ["U3301:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3302",
        type: "menu",
        label: "lblMnuU3302",
        link: "/U3302",
        allowedRoles: ["U3302:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3303",
        type: "menu",
        label: "lblMnuU3303",
        link: "/U3303",
        allowedRoles: ["U3303:READ"],
        showInGlobalSearch: false,
      },
    ],
  },
  {
    id: "U3200",
    type: "module",
    label: "lblMnuModuleAI",
    icon: u2000MenuGetIcon(FaWandMagicSparkles, "h-4 w-4"),
    breadCrumIcon: u2000MenuGetIcon(FaWandMagicSparkles, "h-6 w-6"),
    menuItems: [
      {
        id: "U3204",
        type: "menu",
        label: "lblMnuU3204",
        link: "/U3204",
        allowedRoles: ["U3204:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3204-product-help-admin",
        type: "menu",
        label: "lblMnuU3204ProductHelpAdmin",
        link: "/U3204/admin/product-help",
        allowedRoles: ["U3204:ADMIN"],
        showInGlobalSearch: false,
      },
      {
        id: "U3203",
        type: "menu",
        label: "lblMnuU3203",
        link: "/U3203",
        allowedRoles: ["U3203:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3206",
        type: "menu",
        label: "lblMnuU3206",
        link: "/U3206",
        allowedRoles: ["U3206:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3207",
        type: "menu",
        label: "lblMnuU3207",
        link: "/U3207",
        allowedRoles: ["U3207:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3202",
        type: "menu",
        label: "lblMnuU3202",
        link: "/U3202",
        allowedRoles: ["U3202:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3208",
        type: "menu",
        label: "lblMnuU3208",
        link: "/U3208",
        allowedRoles: ["U3208:READ"],
        showInGlobalSearch: false,
      },
    ],
  },
  {
    id: "U3400",
    type: "module",
    label: "lblMnuModuleU3400",
    icon: u2000MenuGetIcon(FaChartLine, "h-4 w-4"),
    breadCrumIcon: u2000MenuGetIcon(FaChartLine, "h-6 w-6"),
    menuItems: [
      {
        id: "U3400",
        type: "menu",
        label: "lblMnuU3400",
        link: "/U3400",
        allowedRoles: ["U3400:READ"],
        default: true,
        showInGlobalSearch: false,
      },
      {
        id: "U3401",
        type: "menu",
        label: "lblMnuU3401",
        link: "/U3401",
        allowedRoles: ["U3401:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3402",
        type: "menu",
        label: "lblMnuU3402",
        link: "/U3402",
        allowedRoles: ["U3402:READ"],
        showInGlobalSearch: false,
      },
      {
        id: "U3403",
        type: "menu",
        label: "lblMnuU3403",
        link: "/U3403",
        allowedRoles: ["U3403:READ"],
        showInGlobalSearch: false,
      },
    ],
  },
  {
    id: "M3100",
    type: "module",
    label: "lblMnuEmployee",
    icon: u2000MenuGetIcon(FaUser, "h-4 w-4"),
    breadCrumIcon: u2000MenuGetIcon(FaUser, "h-6 w-6"),
    menuItems: [
      {
        id: "U3100",
        type: "menu",
        label: "lblMnuEmployeeManagement",
        link: "/U3101",
        allowedRoles: ["U3101:READ"],
        showInGlobalSearch: true,
        quickSearchFieldName: "codeEmployee",
        quickSearchCondition: "contains",
        quickSearchOrder: 7,
      },
    ],
  },
  {
    id: "U3100",
    type: "module",
    label: "lblMnuConfiguration",
    icon: u2000MenuGetIcon(FaGear, "h-4 w-4"),
    breadCrumIcon: u2000MenuGetIcon(FaGear, "h-6 w-6"),
    // BL-0459 — 2ᵉ niveau : groupes domaine (dossiers sans link)
    menuItems: [
      {
        id: "U3102",
        type: "menu",
        label: "lblMnuU3102",
        link: "/U3102",
        allowedRoles: ["U3102:READ"],
      },
      {
        id: "U3103",
        type: "menu",
        label: "lblMnuU3103",
        link: "/U3103",
        allowedRoles: ["U3103:READ"],
      },
      {
        id: "CFG-PERIODS",
        type: "menu",
        label: "lblMnuCfgPeriods",
        menuItems: [
          {
            id: "U3104",
            type: "menu",
            label: "lblMnuU3104",
            link: "/U3104",
            allowedRoles: ["U3104:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "yearCode",
            quickSearchCondition: "contains",
          },
          {
            id: "U3105",
            type: "menu",
            label: "lblMnuU3105",
            link: "/U3105",
            allowedRoles: ["U3105:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "yearCode",
            quickSearchCondition: "contains",
          },
        ],
      },
      {
        id: "CFG-EXPENSES",
        type: "menu",
        label: "lblMnuCfgExpenses",
        menuItems: [
          {
            id: "U3106",
            type: "menu",
            label: "lblMnuU3106",
            link: "/U3106",
            allowedRoles: ["U3106:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "code",
            quickSearchCondition: "contains",
          },
          {
            id: "U3107",
            type: "menu",
            label: "lblMnuU3107",
            link: "/U3107",
            allowedRoles: ["U3107:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "code",
            quickSearchCondition: "contains",
          },
        ],
      },
      {
        id: "CFG-INVOICE",
        type: "menu",
        label: "lblMnuCfgInvoice",
        menuItems: [
          {
            id: "U3153",
            type: "menu",
            label: "lblMnuU3153",
            link: "/U3153",
            allowedRoles: ["U3153:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "code",
            quickSearchCondition: "contains",
          },
          {
            id: "U3154",
            type: "menu",
            label: "lblMnuU3154",
            link: "/U3154",
            allowedRoles: ["U3154:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "code",
            quickSearchCondition: "contains",
          },
          {
            id: "U3108",
            type: "menu",
            label: "lblMnuU3108",
            link: "/U3108",
            allowedRoles: ["U3108:READ"],
          },
          {
            id: "U3109",
            type: "menu",
            label: "lblMnuU3109",
            link: "/U3109",
            allowedRoles: ["U3109:READ"],
          },
          {
            id: "U3114",
            type: "menu",
            label: "lblMnuU3114",
            link: "/U3114",
            allowedRoles: ["U3114:READ"],
          },
        ],
      },
      {
        id: "CFG-TAXES",
        type: "menu",
        label: "lblMnuCfgTaxes",
        menuItems: [
          {
            id: "U3110",
            type: "menu",
            label: "lblMnuU3110",
            link: "/U3110",
            allowedRoles: ["U3110:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "code",
            quickSearchCondition: "contains",
          },
        ],
      },
      {
        id: "CFG-CUSTOMERS",
        type: "menu",
        label: "lblMnuCfgCustomers",
        menuItems: [
          {
            id: "U3151",
            type: "menu",
            label: "lblMnuU3151",
            link: "/U3151",
            allowedRoles: ["U3151:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "customerTypeCode",
            quickSearchCondition: "contains",
          },
          {
            id: "U3152",
            type: "menu",
            label: "lblMnuU3152",
            link: "/U3152",
            allowedRoles: ["U3152:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "contactTypeCode",
            quickSearchCondition: "contains",
          },
          {
            id: "U3111",
            type: "menu",
            label: "lblMnuU3111",
            link: "/U3111",
            allowedRoles: ["U3111:READ"],
          },
        ],
      },
      {
        id: "CFG-TIMESHEET",
        type: "menu",
        label: "lblMnuCfgTimesheet",
        menuItems: [
          {
            id: "U3149",
            type: "menu",
            label: "lblMnuU3149",
            link: "/U3149",
            allowedRoles: ["U3149:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "workNatureCode",
            quickSearchCondition: "contains",
          },
          {
            id: "U3157",
            type: "menu",
            label: "lblMnuU3157",
            link: "/U3157",
            allowedRoles: ["U3157:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "name",
            quickSearchCondition: "contains",
          },
          {
            id: "U3150",
            type: "menu",
            label: "lblMnuU3150",
            link: "/U3150",
            allowedRoles: ["U3150:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "taskCode",
            quickSearchCondition: "contains",
          },
          {
            id: "U3155",
            type: "menu",
            label: "lblMnuU3155",
            link: "/U3155",
            allowedRoles: ["U3155:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "workNatureCode",
            quickSearchCondition: "contains",
          },
          {
            id: "U3112",
            type: "menu",
            label: "lblMnuU3112",
            link: "/U3112",
            allowedRoles: ["U3112:READ"],
          },
          {
            id: "U3118",
            type: "menu",
            label: "lblMnuU3118",
            link: "/U3118",
            allowedRoles: ["U3118:READ"],
          },
        ],
      },
      {
        id: "U3113",
        type: "menu",
        label: "lblMnuU3113",
        link: "/U3113",
        allowedRoles: ["U3113:READ"],
      },
      {
        id: "U3115",
        type: "menu",
        label: "lblMnuU3115",
        link: "/U3115",
        allowedRoles: ["U3115:READ"],
      },
      {
        id: "U3116",
        type: "menu",
        label: "lblMnuU3116",
        link: "/U3116",
        allowedRoles: ["U3116:READ"],
      },
      {
        id: "CFG-CADASTRE",
        type: "menu",
        label: "lblMnuCfgCadastre",
        menuItems: [
          {
            id: "U3117",
            type: "menu",
            label: "lblMnuU3117",
            link: "/U3117",
            allowedRoles: ["U3117:READ"],
          },
          {
            id: "U3143",
            type: "menu",
            label: "lblMnuU3143",
            link: "/U3143",
            allowedRoles: ["U3143:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "codeDistrict",
            quickSearchCondition: "contains",
          },
          {
            id: "U3144",
            type: "menu",
            label: "lblMnuU3144",
            link: "/U3144",
            allowedRoles: ["U3144:READ"],
            showInGlobalSearch: false,
            quickSearchFieldName: "operationTypeCode",
            quickSearchCondition: "contains",
          },
        ],
      },
    ],
  },
  {
    id: "U2100",
    type: "module",
    label: "lblMnuAdmin",
    icon: u2000MenuGetIcon(FaBriefcase, "h-4 w-4"),
    breadCrumIcon: u2000MenuGetIcon(FaBriefcase, "h-6 w-6"),
    menuItems: [
      {
        id: "U2101",
        type: "menu",
        label: "lblMnulogicalUnit",
        link: "/U2101",
        allowedRoles: ["U2101:READ"],
        default: true,
        showInGlobalSearch: false,
        quickSearchFieldName: "logicalUnitCode",
        quickSearchCondition: "startswith",
      },
      {
        id: "U2107",
        type: "menu",
        label: "lblMnuLogicalUnitCategory",
        link: "/U2107",
        allowedRoles: ["U2107:READ"],
        showInGlobalSearch: false,
        quickSearchFieldName: "code",
        quickSearchCondition: "startswith",
      },
      {
        id: "U2102",
        type: "menu",
        label: "lblMnuRole",
        link: "/U2102",
        allowedRoles: ["U2102:READ"],
        showInGlobalSearch: false,
        quickSearchFieldName: "roleCode",
        quickSearchCondition: "contains",
      },
      {
        id: "U2103",
        type: "menu",
        label: "lblMnuUser",
        link: "/U2103",
        allowedRoles: ["U2103:READ"],
        showInGlobalSearch: false,
        quickSearchFieldName: "username",
        quickSearchCondition: "contains",
      },
      {
        id: "U2104",
        type: "menu",
        label: "lblMnuOrganization",
        link: "/U2104",
        allowedRoles: ["U2104:READ"],
        showInGlobalSearch: false,
        quickSearchFieldName: "organizationName",
        quickSearchCondition: "contains",
      },
      {
        id: "U3148",
        type: "menu",
        label: "lblMnuU3148",
        link: "/U3148",
        allowedRoles: ["U3148:READ"],
        requiresOrganizationId: true,
        showInGlobalSearch: false,
      },
      {
        id: "U2202",
        type: "menu",
        label: "lblMnuConnectedUsers",
        link: "/U2202",
        allowedRoles: ["U2202:READ"],
        showInGlobalSearch: false,
        quickSearchFieldName: "username",
        quickSearchCondition: "contains",
      },
      {
        id: "U2201",
        type: "menu",
        label: "lblMnuJobSchedulers",
        link: "/U2201",
        allowedRoles: ["U2201:READ"],
        showInGlobalSearch: false,
        quickSearchFieldName: "scheduleCode",
        quickSearchCondition: "contains",
      },
    ],
  },
];

// Fonction pour créer une copie profonde et propre du menu de base
// Garantit l'immutabilité du menu original et supprime toutes les propriétés temporaires
export function getCleanMenuCopy(): U2000MenuModule[] {
  const deepCopy = (obj: any): any => {
    if (obj === null || typeof obj !== "object") {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map(deepCopy);
    }

    const copy: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && key !== "hidden") {
        if (key === "allowedRoles" && Array.isArray(obj[key])) {
          // S'assurer que allowedRoles est une nouvelle copie
          copy[key] = [...obj[key]];
        } else {
          copy[key] = deepCopy(obj[key]);
        }
      }
    }
    return copy;
  };

  return deepCopy(u2000Menu);
}

// Gel du menu de base pour empêcher les mutations accidentelles
Object.freeze(u2000Menu);

export function findBreadcrumbPath(menuList: U2000MenuItem[], targetId: string | number, path: U2000MenuItem[] = []): U2000MenuItem[] | null {
  for (const item of menuList) {
    const newPath = [...path, item];
    if (item.id === targetId) {
      return newPath;
    }
    if (item.menuItems) {
      const result = findBreadcrumbPath(item.menuItems, targetId, newPath);
      if (result) return result;
    }
  }
  return null;
}
